import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { logger } from './utils/logger'

// Get environment-specific metadata
const getEnvironmentMetadata = () => {
  const isProduction = import.meta.env.PROD && import.meta.env.MODE === 'production';
  const isStaging = import.meta.env.PROD && import.meta.env.MODE === 'staging';
  const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
  
  return {
    environment: import.meta.env.MODE,
    version: import.meta.env.VITE_APP_VERSION || '0.0.1',
    isDevelopment,
    isStaging,
    isProduction,
    cloudwatchEnabled: Boolean(import.meta.env.VITE_CLOUDWATCH_REGION && import.meta.env.VITE_CLOUDWATCH_GROUP),
    region: import.meta.env.VITE_CLOUDWATCH_REGION,
    logGroup: import.meta.env.VITE_CLOUDWATCH_GROUP
  };
};

// Log application startup with environment-specific information
logger.info('Application started', getEnvironmentMetadata());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
